import { render, staticRenderFns } from "./ModalNotif.vue?vue&type=template&id=20aea209&lang=pug&"
import script from "./ModalNotif.vue?vue&type=script&lang=js&"
export * from "./ModalNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports